import { Flex, Text } from '@chakra-ui/react'
import { LuTriangleAlert as AlertTriangle } from 'react-icons/lu'

interface MiningRightDataWarningProps {
  hasBoundary: boolean
  componentCount: number
}

/**
 * Aviso NO bloqueante para la cabecera del acordeón de cada Derecho Minero.
 *
 * Alerta de que se están por registrar documentos (IGAFOM, otros documentos
 * legales, DPS) contra un D.M. que todavía no tiene georreferenciación ni
 * componentes declarados. No deshabilita nada: el usuario puede continuar, pero
 * queda avisado de que está cargando información sobre un derecho vacío.
 *
 * Observación 11 de la revisión del 09.09.26.
 */
export default function MiningRightDataWarning({ hasBoundary, componentCount }: MiningRightDataWarningProps) {
  const missingBoundary = !hasBoundary
  const missingComponents = componentCount === 0
  if (!missingBoundary && !missingComponents) return null

  const what =
    missingBoundary && missingComponents ? 'sin polígono ni componentes' :
    missingBoundary ? 'sin polígono' :
    'sin componentes'

  return (
    <Flex
      alignItems="center"
      gap={1.5}
      title={`Este derecho minero está ${what}. Puedes continuar, pero conviene completarlo antes de aprobar.`}
    >
      <AlertTriangle size={12} color="#a8740e" />
      <Text
        fontSize="9px"
        fontWeight="bold"
        textTransform="uppercase"
        letterSpacing="0.05em"
        color="#a8740e"
        whiteSpace="nowrap"
      >
        D.M. {what}
      </Text>
    </Flex>
  )
}
